import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { UserState } from './types';

export const selectAdminUser = (state: ApplicationRootState): UserState =>
    state.admin.user || initialState;

export const selectAdminMemberGroupId = (
    state: ApplicationRootState
): number | undefined => state.auth.context.user?.member_group_id;

export const selectUserList = createSelector(
    selectAdminUser,
    (state) => state.list
);
